export default String.raw`
.product-presentation {
    margin: 16px 5%;

    &__top-section {
        .main-content-container {
            padding: 0;

            &.simple-product{
                flex-direction: row;
            }
            
            .buttons-container {
                display: flex;
                justify-content: space-between;
                flex-direction: column;
            }
        }
    }
}

.product-presentation__top-section{
    display: block;
    .product-name-container{
        margin-top: 15px;
        &__buttons-container{
            display: block;
            .buttons{
                margin-top: 15px;
                .pure-button__text{
                    display: none;
                }
                .pure-button__icon{
                    width: 40px;
                    height: 40px;
                    border: 2px solid $secondaryBtnFontColor;
                    border-radius: 5px;
                    padding: 8px;
                }
            }
        }
    }
    .main-content-container.simple-product .main-content-container__attributes{
        display: none;
    }
}
.single-image{
    &__prev, &__next {
        display: none;
    }
    .swiper-pagination {
        display: flex;
        justify-content: center;
        align-items: center;
        bottom: 0px !important;
        &-bullet {
            width: 32px;
            height: 4px;
            background-color: $lighterColor;
            opacity: 1;
            border-radius: 2px;
            margin: 0 5px;
            &-active {
                background-color: $secondaryColor;
            }
        }
    }
} 
.multi-image {
    display: none;
}

.gpsr {
    grid-template-columns: repeat(1, 1fr);
}

.nav-attached-js {
    padding: 0 5%;
}

.product-presentation-forms-popup-background .popup{
    max-width: unset;
    width: 100svw;
    max-height: 100svh;
    height: fit-content;
    padding: 16px 16px 32px 16px;
    top: unset;
    left: unset;
    bottom: 0;
    transform: unset;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;

    &__content{
        max-height: 80vh;
    }
}

body:has(.product-presentation-forms-popup-background) {
    overflow: hidden;
}

.product-label {
    margin: 0;
    .secondary-action-button {
        width: 40px;
        padding: 8px;

        span {
            display: none;
        }

        svg {
            flex-shrink: 0;
            width: 24px;
            height: 24px;
            fill: $secondaryBtnFontColor;
        }
    }

    &__details {
        .name-container {
            .name {
                max-width: 500px !important;
                width: fit-content;
            }
        }
    }
}

.product-attributes {
    .attributes-column {
        grid-template-columns: auto;
    }
}

@media screen and (max-width: 680px) {
    .product-label {
        &__details {
            .name-container {
                .name {
                    max-width: 350px !important;
                }
            }
        }
    }
}

@media screen and (max-width: 540px) {
    .product-label {
        &__details {
            .name-container {
                .name {
                    max-width: 225px !important;
                }
            }
        }
    }
}

.reviews-container {
    &__header {
        flex-direction: column;
        margin-top: 16px;

        .review-overall {
            flex-direction: row;

            .all-opinions {
                flex-direction: column;
            }

            .stars {
                gap: 8px;
            }
        }

        &-subsection {
            flex-direction: column;
            .reviews-summary {
                align-items: center;
                
                &__star-details {
                    width: 100%;
                    
                    .review-bar {
                        width: calc(90% - 40px);

                        span {
                            flex-shrink: 0;
                        }
                    }
                    progress[value] {
                        width: inherit;
                    }
                }
            }
        }
    }

    &__content {
        margin: 0;
        
      .review {
        display: flex;
        flex-direction: column;

        &__details {
          gap: 8px;

          .pure-button {
            align-self: self-end;
            position: absolute;
            right: 5%;
          }
        }
      }

      .no-reviews {
        @include h4-headline;
        flex-direction: row;
        align-items: center;
        gap: 12px;
      }
    }
}

.no-reviews-js {
    flex-direction: column;
    gap: 16px;
}

.sets-container {
    .sets-details {
        gap: 0;
        display: flex;
        width: 100%;
        flex-direction: column;

        .sets {
            margin: 16px 0;
            
            &__price-details {
                flex-direction: column;
                align-items: flex-start;
        
                .primary-action-button {
                    width: 100%;
                }
            }
        }
    } 
}

.related-container {
    .related-details {
        .related {
            margin: 16px 0;

            &__wrapper {
                width: calc(100% / 1.2);
            }
        }
    }
}

.add-review {
    max-width: none;
    padding: 16px 8px 16px 16px;
    
    .review-content {
        padding-right: 8px;
    }
}

.product-navigation {
    .product-label {
        margin: 0;
    }
}

.downloads {
    .attachements {
        display: block;
    }
}
`